import { createContext, useContext } from 'react';

export interface MaisonAdjiCartItem {
  productId: string;
  slug: string;
  name: string;
  nameEn: string | null;
  priceXof: number | null;
  priceEur: number | null;
  quantity: number;
  imageUrl: string;
}

export type MaisonAdjiCartContextValue = {
  items: MaisonAdjiCartItem[];
  totalQuantity: number;
  addItem: (item: Omit<MaisonAdjiCartItem, 'quantity'> & { quantity?: number }) => void;
  removeItem: (productId: string) => void;
  updateQuantity: (productId: string, quantity: number) => void;
};

export const MaisonAdjiCartContext = createContext<MaisonAdjiCartContextValue | null>(null);

export function useMaisonAdjiCart(): MaisonAdjiCartContextValue {
  const ctx = useContext(MaisonAdjiCartContext);
  if (!ctx) throw new Error('useMaisonAdjiCart must be used within MaisonAdjiCartProvider');
  return ctx;
}

export function useMaisonAdjiCartOptional(): MaisonAdjiCartContextValue | null {
  return useContext(MaisonAdjiCartContext);
}
